import { render, staticRenderFns } from "./MerchantPortrait.vue?vue&type=template&id=2c209572&scoped=true"
import script from "./MerchantPortrait.vue?vue&type=script&lang=js"
export * from "./MerchantPortrait.vue?vue&type=script&lang=js"
import style0 from "./MerchantPortrait.vue?vue&type=style&index=0&id=2c209572&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c209572",
  null
  
)

export default component.exports